import { Icon, Stack, styled, Typography } from '@mui/material';

import palette from '../theme/palette';

interface EmptyStateProps {
  text: string;
  icon: React.ReactNode;
}

const EmptyStateContainer = styled(Stack)({
  alignItems: 'center',
  justifyContent: 'center',
  flexGrow: 1
});

const Text = styled(Typography)({
  fontSize: '13px',
  fontWeight: 600,
  color: palette.grey[600]
});

export const EmptyState = ({ text, icon }: EmptyStateProps) => {
  return (
    <EmptyStateContainer>
      <Icon>{icon}</Icon>
      <Text>{text}</Text>
    </EmptyStateContainer>
  );
};
